
import React, {FC, useState} from 'react';
import s from './PriomptSection.module.css';
import PromptBlock from "../promt-block/PromtBlock";
import {useSelector} from "react-redux";
import {selectIsBodyPromptVisible} from "../../../../store/selectors/projectSelectors";
import {BottomSheet} from "react-spring-bottom-sheet";
import useIsMobile from "../../../../shared/hooks/useIsMobile";
import 'react-spring-bottom-sheet/dist/style.css'
import settings from '../../../../assets/img/settings.svg'
const PromptSection: FC = () => {
    const isPromptBlockBody = useSelector(selectIsBodyPromptVisible);
    const isMobile = useIsMobile();
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState<boolean>(false);

    const handleOpenBottomSheet = () => {
        setIsBottomSheetOpen(true);
    };

    const handleCloseBottomSheet = () => {
        setIsBottomSheetOpen(false);
    };

    React.useEffect(() => {
        if (isMobile && isPromptBlockBody) {
            handleOpenBottomSheet();
        } else if (isMobile && !isPromptBlockBody) {
            handleCloseBottomSheet();
        }
    }, [isMobile, isPromptBlockBody]);

    return (
        <div className={s.prompt_section_container}>
            <button className={s.settings} onClick={handleOpenBottomSheet}>
                <img src={settings} className={s.img} />
            </button>

            <div className={s.prompt_block_container}>
            <PromptBlock type="overall" />
            </div>

            {isMobile ? (
                <BottomSheet
                    open={isBottomSheetOpen}
                    onDismiss={handleCloseBottomSheet}
                    snapPoints={({ maxHeight }) => [maxHeight / 2, maxHeight - 10]}
                >
                    <div>
                        <PromptBlock type="tone" />
                        <PromptBlock type="voice" />

                    </div>
                </BottomSheet>
            ) : (
                <>
                    {isPromptBlockBody && (
                        <div className={s.prompt_style}>
                            <PromptBlock type="tone" />
                        </div>
                    )}
                    {isPromptBlockBody && (
                        <div className={s.prompt_block_container_purple}>
                            <PromptBlock type="voice" />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default PromptSection;